import * as React from "react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataLakeQuery } from "@graylog/enterprise-api";
import { Button, Alert } from "components/bootstrap";
import useFeature from "hooks/useFeature";
import DataLakeRoutes from "data-lake/Routes";
import useHistory from "routing/useHistory";
import { ConfirmDialog } from "components/common";
import { PREVIEW_JOB_STATUS } from "data-lake/preview/Constants";
import UserNotification from "util/UserNotification";
const PreviewLakeLogsButtonComponent = ({
  children = void 0,
  bsStyle = void 0,
  bsSize = "xs",
  target = void 0,
  dataLakeId,
  urlParams,
  onClick = void 0
}) => {
  const { t } = useTranslation("enterprise_data_lake");
  const history = useHistory();
  const [isLoadingActiveSearch, setIsLoadingActiveSearch] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const onNavigate = useCallback(() => {
    const url = `${DataLakeRoutes.PREVIEW}?dataLakeId=${dataLakeId}${urlParams ? `&${urlParams}` : ""}`;
    if (target === "_blank") {
      window.open(url, target);
    } else {
      history.push(url);
    }
  }, [dataLakeId, urlParams, target, history]);
  const toggleShowConfirmation = useCallback(() => {
    setShowConfirmDialog((cur) => !cur);
  }, []);
  const onClickHandler = useCallback(() => {
    onClick == null ? void 0 : onClick();
    setIsLoadingActiveSearch(true);
    DataLakeQuery.searchJobExecutionState().then(({ status }) => {
      if (status === PREVIEW_JOB_STATUS.running) {
        toggleShowConfirmation();
      } else {
        onNavigate();
      }
    }).catch((error) => {
      if (error.status === 404) {
        return onNavigate();
      }
      return UserNotification.error(error.message);
    }).finally(() => setIsLoadingActiveSearch(false));
  }, [onClick, onNavigate, toggleShowConfirmation]);
  const onConfirm = useCallback(() => {
    DataLakeQuery.resetActiveQuery().then(() => onNavigate());
  }, [onNavigate]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize,
      title: t("preview_button.title"),
      onClick: onClickHandler,
      disabled: isLoadingActiveSearch,
      bsStyle
    },
    children != null ? children : t("preview_button.label")
  ), showConfirmDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmDialog,
      onConfirm,
      onCancel: toggleShowConfirmation,
      title: t("preview_button.running_title")
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("preview_button.running_text"))
  ));
};
const PreviewLakeLogsButton = ({
  bsSize = void 0,
  bsStyle = void 0,
  children = void 0,
  dataLakeId,
  target = void 0,
  urlParams,
  onClick = void 0
}) => {
  const featureIsEnabled = useFeature("data_lake_search");
  if (!featureIsEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    PreviewLakeLogsButtonComponent,
    {
      urlParams,
      bsStyle,
      bsSize,
      target,
      dataLakeId,
      onClick
    },
    children
  );
};
export default PreviewLakeLogsButton;
